module.exports = __webpack_public_path__ + "static/img/9.6539482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/9.jpg
// module id = rHvN
// module chunks = 0